import React, { useEffect, useRef, useState } from "react";
import agent01 from "../../assets/agent01.png";
import logoNew from "../../assets/logo-new.png";
import call from "../../assets/call_icon.png";
import chat from "../../assets/chat_icon.png";
import message from "../../assets/message_icon.png";
import lock from "../../assets/lock_icon.png";
import search from "../../assets/search.png";
import { useNavigate, useParams } from "react-router-dom";
import axiosInstanceAuth from "../../apiInstances/axiosInstanceAuth";
import { toast } from "react-toastify";
import {
  ChevronDown,
  LockKeyhole,
  Mail,
  MessageCircle,
  MessageCircleMore,
  PhoneCall,
} from "lucide-react";
import CustomSlider from "../common/CustomSlider/CustomSlider";

const AgentAppraisal = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const parentDivRef = useRef(null);

  const emailRegex =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  const [Tracker, setTracker] = useState(1);
  const [allAgentData, setAllAgentData] = useState({});
  const PRICE_MIN = 50000;
  const PRICE_MAX = 15000000;
  const PRICE_STEP = 50000;
  const MAX_OPTIONS = [5000000, 7500000, 10000000, 15000000];

  const [SelectedRange, setSelectedRange] = useState([PRICE_MIN, PRICE_MAX]);

  const [AgentData, setAgentData] = useState({});

  const [RequestData, setRequestData] = useState({
    reason: "",
    first_name: "",
    last_name: "",
    email: "",
    mobile_no: "",
    prefer_to_be_contacted: "Call",
    timeframe: "Now",
    address: "",
    type: "",
    min: String(PRICE_MIN),
    max: String(PRICE_MAX),
    remember_details: false,
  });
  let priceRange = [
    {
      min: RequestData?.min,
    },
    {
      max: RequestData?.max,
    },
  ];

  const onChangeInput = (e) => {
    const { name, value } = e.target;
    setRequestData({ ...RequestData, [name]: value });
  };

  useEffect(() => {
    GetAgentData(id);
  }, []);

  useEffect(() => {
    const nextMax = RequestData?.max ? Number(RequestData.max) : PRICE_MAX;
    if (Number.isFinite(nextMax)) {
      const target = Math.min(PRICE_MAX, Math.max(PRICE_MIN, nextMax));
      const snappedMax = MAX_OPTIONS.reduce((prev, cur) =>
        Math.abs(cur - target) < Math.abs(prev - target) ? cur : prev,
      );
      setSelectedRange([PRICE_MIN, snappedMax]);
    }
  }, [RequestData?.max]);

  const GetAgentData = async (id) => {
    await axiosInstanceAuth
      .post(`Agency_Agent/ViewProfile`, {
        id: id,
      })
      .then((res) => {
        const allAgentData = res?.data;
        setAllAgentData(allAgentData);
        const mydata = res?.data?.data;
        if (res?.data?.status) {
          setAgentData(mydata);
        } else {
        }
      })
      .catch((err) => {
        console.log("err --->", err);
      });
  };

  const ActiveContact =
    "!border-2 !border-[#DBEAFE] !bg-[#EFF6FF] !text-[#000929]";

  const ActiveTimeFrame =
    "!border !border-[#127DDF] !bg-[#EAF4FF] !text-[#127DDF]";

  const SubmitReqest = () => {
    try {
      if (RequestData?.reason === "") {
        toast.error("Please select a reason for requesting appraisal.");
      } else if (RequestData?.first_name === "") {
        toast.error("Please enter your first name.");
      } else if (RequestData?.last_name === "") {
        toast.error("Please enter your last name.");
      } else if (!emailRegex?.test(RequestData?.email)) {
        toast.error("Please enter a valid email address.");
      } else if (RequestData?.address === "") {
        toast.error("Please enter your property address.");
      } else if (RequestData?.type === "") {
        toast.error("Please select a property type.");
      } else {
        const data = {
          agent_id: id,
          reason: RequestData?.reason,
          first_name: RequestData?.first_name,
          last_name: RequestData?.last_name,
          email: RequestData?.email,
          mobile_no: RequestData?.mobile_no,
          prefer_to_be_contacted: RequestData?.prefer_to_be_contacted,
          timeframe: RequestData?.timeframe,
          type: RequestData?.type,
          address: RequestData?.address,
          priceRange: JSON.stringify(priceRange),
          remember_details: RequestData?.remember_details,
        };
        axiosInstanceAuth
          .post(`sendPropertyDetails`, data)
          .then((res) => {
            if (res?.data?.status) {
              toast.success("Appraisal submitted successfully.");
              navigate(`/agent-profile/${id}`);
            } else {
              toast.error(res?.data?.message);
            }
          })
          .catch((err) => {
            console.log("------>> Error", err);
          });
      }
    } catch (error) {
      console.error(error);
    }
  };

  const scrollToTop = () => {
    setTimeout(() => {
      if (parentDivRef.current) {
        parentDivRef.current.scrollIntoView({
          behavior: "smooth",
          block: "center",
          inline: "nearest",
        });
      }
    }, 100);
  };

  return (
    <>
      <div className="bg-[#E7EAF0]">
        <div
          className={`h-[170px] ${AgentData?.agency_id?.primary_color ? "" : "bg-black"}`}
          style={
            AgentData?.agency_id?.primary_color
              ? { backgroundColor: AgentData.agency_id.primary_color }
              : undefined
          }
        >
          <div className="container mx-auto w-full pt-10 px-8">
            <img
              src={AgentData?.agency_id?.agencySmallLogo}
              alt="logo"
              className="h-9 w-auto md:h-11"
            />
          </div>
        </div>
        <div className="-mt-6 pb-14 md:pb-20 px-8">
          <div className="container mx-auto grid w-full grid-cols-1 gap-6 xl:grid-cols-[520px_1fr] px-8">
            <div className="space-y-6">
              <div className="rounded-[20px] border border-[#D9DDE3] bg-[#F8F8F9] p-5 shadow-sm md:p-6">
                <div className="flex items-center gap-4">
                  <img
                    src={AgentData?.profileImg || agent01}
                    alt="Agent"
                    className="h-28 w-28 rounded-full border-[4px] border-[#F3F6F9] object-cover"
                  />
                  <div className="flex flex-col gap-2">
                    <div className="md:text-2xl text-xl font-semibold leading-none text-[#000929]">
                      {AgentData?.first_name || "-"}{" "}
                      {AgentData?.last_name || "-"}
                    </div>
                    <div className="text-base text-[#000929] opacity-75">
                      {"Sales"} | {AgentData?.agency_id?.principal_name || "-"}
                    </div>
                    <div className="flex items-center gap-1 text-base text-[#000929]">
                      <span className="text-[#C8BF09]">★</span>
                      <span className="font-medium">
                        {AgentData?.Rating?.toFixed(1) || "5.0"}
                      </span>
                      <span className="text-[#000929] opacity-75">
                        ({AgentData?.reviews?.length || 0} reviews)
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="rounded-[20px] border border-[#D9DDE3] bg-[#F8F8F9] p-5 shadow-sm md:p-6">
                <div
                  className="flex cursor-pointer items-center gap-4"
                  onClick={() => setTracker(1)}
                >
                  <div
                    className={`flex h-10 w-10 items-center justify-center rounded-full border-[1.5px] text-xl font-semibold ${Tracker === 1
                        ? "border-[#097FE6] bg-[#097FE6] text-white"
                        : "border-[#097FE6] bg-white text-[#097FE6]"
                      }`}
                  >
                    1
                  </div>
                  <div
                    className={`text-lg font-medium md:text-xl ${Tracker === 1
                        ? "text-[#000929]"
                        : "text-[#000929] opacity-50"
                      }`}
                  >
                    Contact Details
                  </div>
                </div>
                <div className="ml-5 h-8 border-l border-dashed border-[#BFC7D1]" />
                <div
                  className="flex cursor-pointer items-center gap-4"
                  onClick={() => setTracker(2)}
                >
                  <div
                    className={`flex h-10 w-10 items-center justify-center rounded-full border-[1.5px] text-xl font-semibold ${Tracker === 2
                        ? "border-[#097FE6] bg-[#097FE6] text-white"
                        : "border-[#097FE6] bg-white text-[#097FE6]"
                      }`}
                  >
                    2
                  </div>
                  <div
                    className={`text-lg font-medium md:text-xl ${Tracker === 2
                        ? "text-[#000929]"
                        : "text-[#000929] opacity-50"
                      }`}
                  >
                    Property Details
                  </div>
                </div>
              </div>
            </div>

            <div className="rounded-[20px] border-[1.5px] border-[#EAEAEA] shadow-[0px_5px_36px_0px_#00000000]  bg-white p-5 md:p-7 lg:p-8">
              {Tracker === 1 && (
                <div className="flex flex-col justify-start">
                  <div className="text-xl font-semibold leading-none text-[#000929] md:text-3xl">
                    Contact Details
                  </div>
                  <div className="mt-7">
                    <div className="flex items-center text-base  text-[#000929]">
                      <span>Reason for requesting appraisal</span>
                      <span className="ml-1 text-[#000929]">*</span>
                    </div>
                    <select
                      name="reason"
                      value={RequestData?.reason}
                      onChange={onChangeInput}
                      className={`mt-3 w-full rounded-2xl border-2 border-[#EAEAEA] bg-[#F8F8F9] px-4 py-3 text-[16px] outline-none transition-all ${!RequestData?.reason
                          ? "text-[#9CA3AF]"
                          : "text-[#000929]"
                        }`}
                    >
                      <option value="" disabled hidden>
                        Please select
                      </option>
                      <option value="Buy House">Buy House</option>
                      <option value="Sell House">Sell House</option>
                      <option value="Rent House">Rent House</option>
                    </select>
                  </div>

                  <div className="mt-5 grid grid-cols-1 gap-3 md:grid-cols-2">
                    <div>
                      <div className="text-base text-[#000929]">
                        First name <span className="text-[#000929]">*</span>
                      </div>
                      <input
                        type="text"
                        name="first_name"
                        value={RequestData?.first_name}
                        onChange={onChangeInput}
                        placeholder="Enter first name"
                        className="mt-3 w-full rounded-2xl border border-[#EAEAEA] bg-[#F8F8F9] px-4 py-3  text-[16px] text-[#000929] outline-none placeholder:text-[#9CA3AF]"
                      />
                    </div>
                    <div>
                      <div className="text-base text-[#000929]">
                        Last name <span className="text-[#000929]">*</span>
                      </div>
                      <input
                        type="text"
                        name="last_name"
                        value={RequestData?.last_name}
                        onChange={onChangeInput}
                        placeholder="Enter last name"
                        className="mt-3 w-full rounded-2xl border border-[#EAEAEA] bg-[#F8F8F9] px-4 py-3  text-[16px] text-[#000929] outline-none placeholder:text-[#9CA3AF]"
                      />
                    </div>
                  </div>

                  <div className="mt-5 grid grid-cols-1 gap-3 md:grid-cols-2">
                    <div>
                      <div className="text-base text-[#000929]">
                        Email <span className="text-[#000929]">*</span>
                      </div>
                      <input
                        type="email"
                        name="email"
                        value={RequestData?.email}
                        onChange={onChangeInput}
                        placeholder="Enter email address"
                        className="mt-3 w-full rounded-2xl border border-[#EAEAEA] bg-[#F8F8F9] px-4 py-3  text-[16px] text-[#000929] outline-none placeholder:text-[#9CA3AF]"
                      />
                    </div>
                    <div>
                      <div className="text-base text-[#000929]">
                        Mobile phone number{" "}
                        <span className="text-[#000929]">*</span>
                      </div>
                      <input
                        type="number"
                        name="mobile_no"
                        value={RequestData?.mobile_no}
                        onChange={onChangeInput}
                        placeholder="Enter mobile phone number"
                        className="mt-3 w-full rounded-2xl border border-[#EAEAEA] bg-[#F8F8F9] px-4 py-3  text-[16px] text-[#000929] outline-none placeholder:text-[#9CA3AF]"
                      />
                    </div>
                  </div>

                  <div className="mt-7 text-base text-[#000929] opacity-50">
                    We will Send you a one-time verification code to confirm
                    your mobile number.
                  </div>

                  <div className="mt-7 text-base text-[#000929]">
                    How would you prefer to be contacted?
                  </div>
                  <div className="mt-4 grid grid-cols-1 gap-3 sm:grid-cols-3">
                    <div
                      className={`flex cursor-pointer flex-col items-center justify-center rounded-2xl px-3 py-8 text-center ${RequestData?.prefer_to_be_contacted === "Call"
                          ? ActiveContact
                          : "border-2 border-[#EAEAEA] bg-white"
                        }`}
                      onClick={() =>
                        setRequestData({
                          ...RequestData,
                          prefer_to_be_contacted: "Call",
                        })
                      }
                    >
                      <PhoneCall
                        size={45}
                        className={`${RequestData?.prefer_to_be_contacted === "Call"
                            ? "text-[#097FE6]"
                            : "text-[#000929]"
                          }`}
                      />
                      <div
                        className={`mt-3 text-base font-medium md:text-xl ${RequestData?.prefer_to_be_contacted === "Call"
                            ? "text-[#000929]"
                            : "text-[#000929] opacity-50"
                          }`}
                      >
                        Call Now
                      </div>
                    </div>
                    <div
                      className={`flex cursor-pointer flex-col items-center justify-center rounded-2xl border px-3 py-8 text-center ${RequestData?.prefer_to_be_contacted === "SMS"
                          ? ActiveContact
                          : "border-[#D8DCE3] bg-white text-[#6B7280]"
                        }`}
                      onClick={() =>
                        setRequestData({
                          ...RequestData,
                          prefer_to_be_contacted: "SMS",
                        })
                      }
                    >
                      <MessageCircleMore
                        size={45}
                        className={`${RequestData?.prefer_to_be_contacted === "SMS"
                            ? "text-[#097FE6]"
                            : "text-[#000929]"
                          }`}
                      />
                      <div
                        className={`mt-3 text-base font-medium md:text-xl ${RequestData?.prefer_to_be_contacted === "SMS"
                            ? "text-[#000929]"
                            : "text-[#000929] opacity-50"
                          }`}
                      >
                        SMS Now
                      </div>
                    </div>
                    <div
                      className={`flex cursor-pointer flex-col items-center justify-center rounded-2xl border px-3 py-8 text-center ${RequestData?.prefer_to_be_contacted === "Email"
                          ? ActiveContact
                          : "border-[#D8DCE3] bg-white text-[#6B7280]"
                        }`}
                      onClick={() =>
                        setRequestData({
                          ...RequestData,
                          prefer_to_be_contacted: "Email",
                        })
                      }
                    >
                      <Mail
                        size={45}
                        className={`${RequestData?.prefer_to_be_contacted === "Email"
                            ? "text-[#097FE6]"
                            : "text-[#000929]"
                          }`}
                      />
                      <div
                        className={`mt-3 text-base font-medium md:text-xl ${RequestData?.prefer_to_be_contacted === "Email"
                            ? "text-[#000929]"
                            : "text-[#000929] opacity-50"
                          }`}
                      >
                        Email Now
                      </div>
                    </div>
                  </div>

                  <div className="mt-6 flex items-start gap-6">
                    <LockKeyhole size={80} className="text-[#097FE6] -mt-5" />
                    <div className="text-[16px] text-[#000929]">
                      Your phone and email will not be used for marketing
                      purposes or shared with any third parties not related to
                      your property appraisal. See our{" "}
                      <span className="cursor-pointer underline">
                        Personal Information Collection Statement.
                      </span>
                    </div>
                  </div>

                  <button
                    className="mt-7 w-full rounded-full bg-[#127DDF] px-5 py-4 text-[18px] font-medium text-white transition hover:bg-[#0B69BF]"
                    onClick={() => {
                      setTracker(2);
                      scrollToTop();
                    }}
                  >
                    Continue
                  </button>
                </div>
              )}

              {Tracker === 2 && (
                <div className="flex flex-col justify-start py-2 md:py-4">
                  <div className="font-semibold text-[#000929] text-xl  md:text-3xl">
                    Property Details
                  </div>

                  <div
                    className="flex flex-col md:flex-row justify-center gap-4 mt-5 "
                    ref={parentDivRef}
                  >
                    <div className="w-full">
                      <div className=" text-[#000929] text-sm md:text-base">
                        What is your selling timeframe?
                        <span className="px-1 text-[#000929]">*</span>
                      </div>

                      <div className="flex flex-wrap items-center font-medium text-start text-xs md:text-sm lg:text-base gap-2 mt-4">
                        <div
                          className={`flex w-fit py-3 px-7 items-center justify-center gap-2 border rounded-full ease-in-out duration-500 cursor-pointer ${RequestData?.timeframe === "Now"
                              ? "border-[#127DDF] bg-[#EAF4FF] text-[#127DDF]"
                              : "border-[#E5E5E5] bg-white text-[#737373]"
                            }`}
                          onClick={() => {
                            setRequestData({
                              ...RequestData,
                              timeframe: "Now",
                            });
                          }}
                        >
                          {RequestData?.timeframe === "Now" && (
                            <span className="shrink-0 w-4 h-4 rounded-full bg-[#127DDF] flex items-center justify-center">
                              <span className="w-2 h-2 rounded-full bg-white" />
                            </span>
                          )}
                          <span>Now</span>
                        </div>
                        <div
                          className={`w-fit py-3 px-7 flex items-center justify-center gap-2 border rounded-full ease-in-out duration-500 cursor-pointer ${RequestData?.timeframe === "1 to 3 Months"
                              ? "border-[#127DDF] bg-[#EAF4FF] text-[#127DDF]"
                              : "border-[#E5E5E5] bg-white text-[#737373]"
                            }`}
                          onClick={() => {
                            setRequestData({
                              ...RequestData,
                              timeframe: "1 to 3 Months",
                            });
                          }}
                        >
                          {RequestData?.timeframe === "1 to 3 Months" && (
                            <span className="shrink-0 w-4 h-4 rounded-full bg-[#127DDF] flex items-center justify-center">
                              <span className="w-2 h-2 rounded-full bg-white" />
                            </span>
                          )}
                          <span>1 to 3 Months</span>
                        </div>
                        <div
                          className={`w-fit py-3 px-7 flex items-center justify-center gap-2 border rounded-full ease-in-out duration-500 cursor-pointer ${RequestData?.timeframe === "4 to 6 Months"
                              ? "border-[#127DDF] bg-[#EAF4FF] text-[#127DDF]"
                              : "border-[#E5E5E5] bg-white text-[#737373]"
                            }`}
                          onClick={() => {
                            setRequestData({
                              ...RequestData,
                              timeframe: "4 to 6 Months",
                            });
                          }}
                        >
                          {RequestData?.timeframe === "4 to 6 Months" && (
                            <span className="shrink-0 w-4 h-4 rounded-full bg-[#127DDF] flex items-center justify-center">
                              <span className="w-2 h-2 rounded-full bg-white" />
                            </span>
                          )}
                          <span>4 to 6 Months</span>
                        </div>
                        <div
                          className={`w-fit py-3 px-7 flex items-center justify-center gap-2 border rounded-full ease-in-out duration-500 cursor-pointer ${RequestData?.timeframe === "Not Sure"
                              ? "border-[#127DDF] bg-[#EAF4FF] text-[#127DDF]"
                              : "border-[#E5E5E5] bg-white text-[#737373]"
                            }`}
                          onClick={() => {
                            setRequestData({
                              ...RequestData,
                              timeframe: "Not Sure",
                            });
                          }}
                        >
                          {RequestData?.timeframe === "Not Sure" && (
                            <span className="shrink-0 w-4 h-4 rounded-full bg-[#127DDF] flex items-center justify-center">
                              <span className="w-2 h-2 rounded-full bg-white" />
                            </span>
                          )}
                          <span>Not Sure</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="mt-4 md:mt-6">
                    <div className="text-[#000929] text-sm md:text-base">
                      Property address
                      <span className="px-1 text-[#000929]">*</span>
                    </div>
                    <div className="w-full flex justify-start items-center !text-[#737373] text-xs md:text-sm lg:text-base outline-none border-2 border-[#EAEAEA] rounded-xl py-3 px-4 cursor-pointer mt-2 md:mt-4">
                      <img
                        src={search}
                        alt="icon"
                        className="w-3 lg:w-4 mr-3 cursor-pointer"
                      />
                      <input
                        type="text"
                        name="address"
                        value={RequestData?.address}
                        onChange={onChangeInput}
                        placeholder="Search by Address"
                        className="w-full text-[#737373] font-medium text-xs md:text-sm lg:text-base outline-none"
                      />
                    </div>
                    <div className="text-[#404040] text-xs lg:text-sm mt-2 px-2">
                      Can’t find your property?
                      <span className="px-1 text-[#097FE6] font-medium">
                        Enter address detail manually
                      </span>
                    </div>
                  </div>

                  <div className="mt-4 md:mt-6">
                    <div className="text-[#000929] text-sm md:text-base">
                      Property type
                      <span className="px-1 text-[#000929]">*</span>
                    </div>
                    <select
                      name="type"
                      value={RequestData?.type}
                      onChange={onChangeInput}
                      className="round w-full !text-[#737373] text-xs md:text-sm lg:text-base outline-none border-2 border-[#EAEAEA] rounded-xl py-3 px-5 cursor-pointer mt-2 md:mt-4"
                    >
                      <option value="">Select property type...</option>
                      <option value="Residential">Residential</option>
                      <option value="Commercial">Commercial</option>
                      <option value="Industrial">Industrial</option>
                    </select>
                  </div>

                  <div className="flex flex-col justify-center gap-6 text-xs md:text-sm lg:text-base mt-4 md:mt-6">
                    <div className="text-[#000929] ">
                      What is your sale price expectation?
                    </div>
                    <div className="grid place-items-center">
                      <CustomSlider
                        SelectedRange={SelectedRange}
                        setSelectedRange={setSelectedRange}
                        min={PRICE_MIN}
                        max={PRICE_MAX}
                        step={PRICE_STEP}
                        showGraph={true}
                        onRangeChange={(range) => {
                          if (!Array.isArray(range) || range.length !== 2) return;
                          const rawMax = Number(range[1]);
                          const target = Math.min(PRICE_MAX, Math.max(PRICE_MIN, rawMax));
                          const snappedMax = MAX_OPTIONS.reduce((prev, cur) =>
                            Math.abs(cur - target) < Math.abs(prev - target) ? cur : prev,
                          );
                          setSelectedRange([PRICE_MIN, snappedMax]);
                          setRequestData((prev) => ({
                            ...prev,
                            min: String(PRICE_MIN),
                            max: String(snappedMax),
                          }));
                        }}
                      />
                    </div>
                    <div className="flex flex-col md:flex-row justify-center items-center gap-4">
                      <div className="relative w-full  rounded-2xl border-2 border-[#EAEAEA] bg-white px-5 py-2">
                        <span className="block text-xs text-[#737373]">
                          Min
                        </span>
                        <select
                          name="min"
                          value={RequestData?.min}
                          onChange={onChangeInput}
                          className="w-full appearance-none border-0 bg-transparent  pr-8 text-base font-medium text-[#000929] outline-none cursor-pointer"
                          disabled
                        >
                          <option value={String(PRICE_MIN)}>$50,000</option>
                        </select>
                        <ChevronDown className="absolute right-3 top-1/2 h-5 w-5 -translate-y-1/2 pointer-events-none text-[#000929]" />
                      </div>
                      <div className="relative w-full  rounded-2xl border-2 border-[#EAEAEA] bg-white px-5 py-2">
                        <span className="block text-xs text-[#737373]">
                          Max
                        </span>
                        <select
                          name="max"
                          value={RequestData?.max}
                          onChange={onChangeInput}
                          className="w-full appearance-none border-0 bg-transparent pr-8 text-base font-medium text-[#000929] outline-none cursor-pointer"
                        >
                          {MAX_OPTIONS.map((v) => (
                            <option key={v} value={String(v)}>
                              ${v.toLocaleString("en-US")}
                            </option>
                          ))}
                        </select>
                        <ChevronDown className="absolute right-3 top-1/2 h-5 w-5 -translate-y-1/2 pointer-events-none text-[#000929]" />
                      </div>
                    </div>
                  </div>

                  <div className="text-[#000929] opacity-60 text-xs md:text-sm lg:text-base mt-5 md:mt-12">
                    This will enable the agent to focus on the right comparable
                    sales prior to meeting you.
                  </div>

                  <div className="flex flex-col gap-2 justify-start items-start mt-5 md:mt-12">
                    <p className="text-[#000929] text-xs md:text-sm lg:text-base">
                      Save time contacting more agents
                    </p>
                    <div className="flex items-start">
                      <input
                        type="checkbox"
                        name="remember_details"
                        checked={RequestData?.remember_details}
                        onChange={(e) =>
                          setRequestData({
                            ...RequestData,
                            remember_details: e.target.checked,
                          })
                        }
                        className="w-4 h-4 mt-2 mr-3 md:mr-5 cursor-pointer accent-[#097FE6]!"
                      />
                      <div className="text-[#000929] text-sm md:text-base">
                        <div>
                          Remember these details to complete this form faster.
                        </div>
                        <div className=" text-[#737373] text-xs  mt-1">
                          Details are stored in this web browser for one hour.
                          Clear this checkbox if you are using a public or
                          shared device.
                        </div>
                      </div>
                    </div>
                  </div>

                  <button
                    className="w-full text-xs md:text-sm lg:text-base font-medium border bg-[#127DDF] text-white hover:bg-white hover:text-[#127DDF] hover:border-[#127DDF] py-3 px-5 rounded-3xl mt-5 md:mt-12"
                    onClick={SubmitReqest}
                  >
                    Request a Free Market Appraisal
                  </button>

                  <div className="text-[#000929] text-center text-xs md:text-sm mt-4 md:mt-6 opacity-60">
                    A notification will be sent to the selected agent(s). The
                    agent must accept your request in order to see your contact
                    details and respond to you. If no agent accepts your
                    request, a member of our team will let you know.
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AgentAppraisal;
